export const PASTEL_BLUE = '#aeeff0';
export const PASTEL_RED = '#ffe0e0';
export const PASTEL_GREEN = '#d6f8b8';
export const PASTEL_PURPULE = '#c6cfff';
export const PASTEL_YELLOW = '#f1f0d1';
